module.exports = __webpack_public_path__ + "img/containerFrontLeft.526e92f4.svg";